import { CardSection } from '@/_components/ui/card'

/**
 * @deprecated Use `CardSection` from `@/_components/ui/card` directly.
 */
export const ContentContainer = CardSection
